<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Contatti', route: '/backoffice/contatti/' }, { label: 'Aggiungi Contatto', route: '/backoffice/contatti/add' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">AGGIUNGI CONTATTO</h1>
</section>


<section class="pb-16 mb-8 px-container"> 
    <form [formGroup]="formContatti" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">                                                                
            <div class="w-full">
                <label>* Titolo</label>
                <input type="text" pInputText placeholder="Titolo" formControlName="titolo" name="titolo" id="titolo" required />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formContatti.get('titolo')?.hasError('required') && (formContatti.get('titolo')?.dirty || formContatti.get('titolo')?.touched)">Il titolo è obbligatorio!.</small>
            </div>                                                                     
            <div class="w-full">
                <label>* Descrizione</label>
                <p-editor [style]="{ height: '150px' }" formControlName="descrizione" (ngModelChange)="onDescrizione($event)" />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formContatti.get('descrizione')?.hasError('required') && (formContatti.get('descrizione')?.dirty || formContatti.get('descrizione')?.touched)">La descrizione è obbligatorio!.</small>
            </div>                
            <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formContatti.valid">Aggiungi</button>
        </div>
    </form>
</section>